import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';

import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { RegisterComponent } from './register/register.component';
import { ConfirmRegistrationComponent } from './register/confirm-registration.component';
import { ResetPasswordComponent } from './register/reset-password.component';
import { ForgotUsernameComponent } from './register/forgot-username.component';
import { ConsultationRoomComponent } from './consultation-room/consultation-room.component';
import { PerformanceComponent } from './performance/performance.component';
import { LabsComponent } from './labs/labs.component';
import { VisitsComponent } from './visits/visits.component';
import { PrescriptionsComponent } from './prescriptions/prescriptions.component';
import { VisitComponent } from './visits/visit.component';

// Provider Profile
import { ProfileTabsComponent } from './providers/profile-tabs.component';

// Queue
import { PatientQueueComponent } from './patient-queue/patient-queue.component';

export const routes: Routes = [
  // { path: '', component: DashboardComponent },
  { path: '', component: PatientQueueComponent, canActivate: [AuthGuard] },

  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'register/step/:step', component: RegisterComponent },
  { path: 'confirm/:token', component: ConfirmRegistrationComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'forgot-username', component: ForgotUsernameComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'consultation/:visitId', component: ConsultationRoomComponent, canActivate: [AuthGuard] },
  { path: 'queue', component: PatientQueueComponent, canActivate: [AuthGuard] },
  { path: 'performance', component: PerformanceComponent, canActivate: [AuthGuard] },
  { path: 'labs', component: LabsComponent, canActivate: [AuthGuard] },
  { path: 'visits', component: VisitsComponent, canActivate: [AuthGuard] },
  { path: 'prescriptions', component: PrescriptionsComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileTabsComponent, canActivate: [AuthGuard] },
  { path: 'profile/:tab', component: ProfileTabsComponent, canActivate: [AuthGuard] },
  { path: 'queue', component: PatientQueueComponent, canActivate: [AuthGuard] },
  { path: 'visits/:visitId', component: VisitComponent, canActivate: [AuthGuard] }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts